<onyx-custom-icon
  source="flags/{{ countryCode() }}.svg"
  [size]="size() - 2"
  [onyxTooltip]="`country.${countryCode()}`"
  [onyxTooltipColor]="tooltipColor()"
  [onyxTooltipDisabled]="!showTooltip()"
></onyx-custom-icon>
